"use strict";

import angular from "angular";

import template from "./chart-custom-categories.component.html";
import "./themes/chart-custom-categories-dark.component.scss";
import "./themes/chart-custom-categories.component.scss";

import _ from "lodash";

import { HighchartsFormaterStrutureAdapter } from "../../../presentation/adpters/HighchartsFormaterStrutureAdapter/HighchartsFormaterStrutureAdapter";

import { ColorService } from "../../../presentation/services/ColorService/ColorService";
import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";

class ChartCustomCategoriesComponent {
    constructor($stateParams, $filter, ThemesService) {
        this.$stateParams = $stateParams;
        this.$filter = $filter;

        this.ThemesService = ThemesService;

        this.ColorService = new ColorService({
            ThemesService: this.ThemesService
        });

        this.FormatUnits = new FormatUnits(this.$filter);

        this.HighchartsFormaterStrutureAdapter = new HighchartsFormaterStrutureAdapter(
            {}
        );

        this.companyId = this.$stateParams.id;

        this.visualization = {};
    }

    $onInit() {
        this._setVisualization();
    }

    $onChanges(changes) {
        if (
            _.get(changes, "points.previousValue") &&
            _.get(changes, "series.previousValue")
        ) {
            this._setVisualization();
        }

        if (
            !_.isEmpty(_.get(changes, "currentComparation.previousValue")) ||
            _.get(changes, "series.currentValue.length")
        ) {
            this._setVisualization();
        }
    }

    _getCategories({ series = this.series } = {}) {
        if (!series) return [];
        return series.map((s) => s.name);
    }

    _getPoint({ points = this.points, serie } = {}) {
        const point = points.find(
            (p) => p.s === serie._id && +p.t === +this.currentPeriod.date
        );

        return _.get(point, "m.v", 0);
    }

    _modelerSeriesNormal(series = this.series) {
        if (!series) return [];

        return [
            {
                data: series.map((s, i) => {
                    return {
                        y: this._getPoint({ serie: s }),
                        color: this.ColorService.colorByPath(
                            this.configs.series[i].color
                        ),
                        unit: s.unit
                    };
                })
            }
        ];
    }

    _modelerSeriesStacked(series = this.series) {
        if (!series) return [];

        return series.map((s, i) => {
            return {
                name: s.name,
                data: [
                    {
                        y: this._getPoint({ serie: s }),
                        unit: s.unit,
                        color: this.ColorService.colorByPath(
                            this.configs.series[i].color
                        )
                    }
                ]
            };
        });
    }

    _getSeriesStructure({ series = this.series } = {}) {
        if (this.configs.stacked) return this._modelerSeriesStacked(series);
        else return this._modelerSeriesNormal(series);
    }

    _setVisualization() {
        if (
            this.currentComparation.active ||
            this.projection ||
            this.budget ||
            this.goals
        )
            this._setVisualizationComparation();
        else this._setVisualizationCustom();
    }

    _setVisualizationCustom() {
        const _formatValue = this.FormatUnits.formatValue;

        const stacked = this.configs.stacked;

        const seriesCategories = stacked ? this.highlightsSeries : this.series;

        const structure = {
            title: {
                text: ""
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            chart: {
                type: "column"
            },
            xAxis: {
                categories: this._getCategories({ series: seriesCategories })
            },
            yAxis: { title: { text: "" } },
            legend: {
                enabled: false
            },
            series: this._getSeriesStructure(),
            plotOptions: {
                series: {
                    borderWidth: 0
                },
                column: {
                    stacking: "normal",
                    cursor: "pointer"
                }
            },
            tooltip: {
                backgroundColor: "#f4f4f4",
                style: {
                    color: "black",
                    font: "9pt Open Sans"
                },
                formatter: function () {
                    if (this.series) {
                        return `${
                            stacked ? this.series.name : this.key
                        } ${_formatValue(
                            _.get(this.point, "unit", "int"),
                            this.y,
                            2
                        )}`;
                    }
                }
            }
        };

        structure.yAxis = this.HighchartsFormaterStrutureAdapter.formatYAxis({
            series: this.series,
            structure
        });

        this.visualization.chart = structure;
    }

    _setVisualizationComparation() {
        const structure = {
            title: {
                text: ""
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            plotOptions: {
                series: {
                    borderWidth: 0
                },
                column: {
                    stacking: "normal",
                    cursor: "pointer"
                }
            },
            chart: {
                type: "column"
            },
            yAxis: { title: { text: "" } },
            legend: {
                enabled: true
            },
            series: this.configs.series.map((s, i) => {
                return {
                    _id: s._id,
                    type: s.type,
                    color: s.color
                };
            })
        };
        if (this.goals) structure.goals = this.configs.goals;
        this.visualization.chart = structure;
    }
}

ChartCustomCategoriesComponent.$inject = [
    "$stateParams",
    "$filter",
    "ThemesService"
];

const name = "chartCustomCategoriesComponent";
const def = {
    bindings: {
        series: "<",
        highlightsSeries: "<",
        configs: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        fakeData: "<",
        points: "<",
        projection: "<",
        budget: "<",
        goals: "<"
    },
    controller: ChartCustomCategoriesComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
